export default "__VITE_ASSET__BerBxs_2__"